import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CommonService } from '../../../commons/services/common.service';
import * as moment from 'moment';
import * as $$ from 'jquery';

@Component({
  selector: 'app-equipe-ecoloc',
  templateUrl: './equipe-ecoloc.component.html',
  styleUrls: ['./equipe-ecoloc.component.css']
})
export class EquipeEcolocComponent implements OnInit {
  @Input() mouvement;
  @Input() dateDebut;
  @Input() dateFin;
  @Input() sitePrestEdit;
  @Input() isHistoLoc;
  @ViewChild('msg') msg;
  @ViewChild('qualificationTemp') qualificationTemp;
  @Output() hidefunction = new EventEmitter<any>();
  @Output() save = new EventEmitter<any>();
  dataQualification = [];
  dataQualificationTrue = [];
  listPersodefault = [];
  listPersoPonctuel = [];
  objEquipe: any = {};
  selectedQual = {};
  filtreFirstLetter
  listQualification: any[] = [];
  listLieu: any[] = [{ id: 0, libelleObjetEntite: 'Non spécifié' }];
  listLieuDepart: any[] = [{ id: 0, libelleObjetEntite: 'Non spécifié' }];
  societe: any = {};
  loadingIndicator: Boolean = false;
  chauffEdit: any = {};
  error = '';
  
  constructor(public common: CommonService,
    public modalService: BsModalService) { }

  ngOnInit() {
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.parseMouvement();
    this.getListLieuDepart();
  }

  selectchauff(chauf) {
    this.chauffEdit = chauf ? chauf.id || 0 : 0;
  }

  selectedChauffeurParDefaut(row, chauff, value) {
    const listChauff = [];
    if (this.objEquipe['leaderEquipe']) {
      listChauff.push(this.objEquipe['leaderEquipe'].id || 0);
    }

    this.objEquipe['listePersonnelParPoste'] = this.objEquipe['listePersonnelParPoste'] || [];
    this.objEquipe['listePersonnelParPoste'].forEach(elt => {
      if (elt.personnelDefaut && !elt.personnelDefaut.posteSupprime) {
        listChauff.push(elt.personnelDefaut.id || 0);
      }
    });
    const existe = listChauff.find(t => t === value.id);
    row[chauff] = row[chauff] || {id: 0};
    if (existe && this.chauffEdit !== row[chauff].id) {
      this.error = 'Ce personnel est déjà présent dans l\'équipe.';
      this.common.openModal(this.modalService, this.msg);
      setTimeout(() => {row[chauff] = {id: 0, libelleObjetEntite: 'A définir'};}, 150);
    } else {
      row[chauff] = value;
    }
  }

  searchPersodefault(event, qualif) {
    // this.listPersodefault = [];
    const mvt = this.objEquipe['mouvement'] || { id: 0 };
    console.log()
    // const date = moment(this.date).format('DD/MM/YYYY');
    const datestart = moment(this.common.parseDate(this.dateDebut)).format('DD/MM/YYYY');
    const dateend = moment(this.common.parseDate(this.dateFin)).format('DD/MM/YYYY');
    // if (mvt.dateEnlevement && typeof mvt.dateEnlevement === 'string' &&
    //   (mvt.dateEnlevement || '').match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)) {
    //   date = (moment(mvt.dateEnlevement, 'DD/MM/YYYY').isValid() ?
    //     moment(mvt.dateEnlevement, 'DD/MM/YYYY').format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'));
    // } else {
    //   date = moment(mvt.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
    // }

    const listChauff = [];
    if (this.objEquipe['leaderEquipe']) {
      listChauff.push(this.objEquipe['leaderEquipe'].id || 0);
    }

    const listePersonnelParPoste = this.listePersonnelParPoste() || [];
    listePersonnelParPoste.forEach(elt => {
      if (elt.personnelDefaut && !elt.personnelDefaut.posteSupprime) {
        listChauff.push(elt.personnelDefaut.id || 0);
      }
    })

    const param = {
      'servlet': 'DBGetListChauffeurRH',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'SITE': {
          'typeParam': 'int',
          'valeur': this.sitePrestEdit ? this.sitePrestEdit : this.common.user[2]
        },
        'DATE': {
          'typeParam': 'date',
          'valeur': 'null'
        },
        'DATE_DEBUT': {
          'typeParam': 'date',
          'valeur': datestart
        },
        'DATE_FIN': {
          'typeParam': 'date',
          'valeur': dateend
        },
        'IS_MULTIBENNE': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'FILTRE_TEXTE': '' + event,
        'CLEF_QUALIFICATION': {
          'typeParam': 'int',
          'valeur': 0
        },
        'IS_FILTRER_INTERIMAIRES': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IS_FILTRER_INDISPONIBLES': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IS_FILTRER_JOUR_TRAVAIL': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IS_FILTRER_CHAUFFEUR': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IS_FILTRER_INTERIMAIRES_ASSIGNATION': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'NE_PAS_INCLURE_INTERIMAIRE': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_VISIBLE_PLANNING': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_ENTRETIEN_BAC': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'FILTRER_CONTRAT_PERSO': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'AJOUTER_INTERIMAIRE_EN_MISSION': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        // this.listPersodefault = [...[{ id: 0, libelleObjetEntite: 'A définir' }], ...(datas.data || [])];
        // this.listPersodefault.forEach(elt => {
        //   if (elt.id) {
        //     elt.libelleObjetEntite = `${elt.matricule || ''} ${elt.nom || ''} ${elt.prenom || ''}`
        //   }
        // });

        const data = datas.data || [];
        this.listPersodefault = data.length ? [{ id: 0, libelleObjetEntite: 'A définir' }] : [];

        data.forEach(elt => {
          console.log(listChauff)
          const existe = listChauff.find(t => t === elt.id);
          if (!existe || (this.chauffEdit === elt.id)) {
            if (elt.id) {
              elt.libelleObjetEntite = `${elt.matricule || ''} ${elt.nom || ''} ${elt.prenom || ''}`
            }
            // elt.libelleObjetEntite = `${elt.matricule || ''} ${elt.nom || ''} ${elt.prenom || ''}`;
            this.listPersodefault.push(elt);
          }
        });
      }
    });
  }

  selectedChauffeurPonctuel(row, chauff, value) {
    const listChauff = [];
    if (this.objEquipe['chauffeur']) {
      listChauff.push(this.objEquipe['chauffeur'].id || 0);
    }
    this.objEquipe['listePersonnelParPoste'] = this.objEquipe['listePersonnelParPoste'] || [];
    this.objEquipe['listePersonnelParPoste'].forEach(elt => {
      if (elt.chauffeur && !elt.chauffeur.posteSupprime) {
        listChauff.push(elt.chauffeur.id || 0);
      }
    })
    const existe = listChauff.find(t => t === value.id);
    row[chauff] = row[chauff] || {id: 0};
    if (existe && this.chauffEdit !== row[chauff].id) {
      this.error = 'Ce personnel est déjà présent dans l\'équipe.';
      this.common.openModal(this.modalService, this.msg);
      setTimeout(() => {row[chauff] = {id: 0, libelleObjetEntite: 'A définir'};}, 150);
    } else {
      row[chauff] = value;
    }
  }

  searchPersoPonctuel(event, qualif) {
    // this.listPersoPonctuel = [];
    const mvt = this.objEquipe['mouvement'] || { id: 0 };
    const bon = mvt.bon;
    const periode = mvt.periode;
    // const date = moment(mvt.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
    const datestart = moment(this.common.parseDate(this.dateDebut)).format('DD/MM/YYYY');
    const dateend = this.societe['verifIndispoPremierJour']  ? datestart : moment(this.common.parseDate(this.dateFin)).format('DD/MM/YYYY');

    const camion = mvt.camion;
    const tabClefBon = [];
    this.objEquipe['listeMouvements'] = this.objEquipe['listeMouvements'] || [];
    this.objEquipe['listeMouvements'].forEach(elt => {
      const b = elt.bon;
      tabClefBon.push('' + (b ? b.id : 0));
    });
    const listChauff = [];
    if (this.objEquipe['chauffeur']) {
      listChauff.push(this.objEquipe['chauffeur'].id || 0);
    }
    this.objEquipe['listePersonnelParPoste'] = this.objEquipe['listePersonnelParPoste'] || [];
    this.objEquipe['listePersonnelParPoste'].forEach(elt => {
      if (elt.chauffeur && !elt.chauffeur.posteSupprime) {
        listChauff.push(elt.chauffeur.id || 0);
      }
    })
    const param = {
      'servlet': 'DBGestionMaterielLoue',
      'module': 'Ecoloc',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.sitePrestEdit ? this.sitePrestEdit : this.common.user[2]
        },
        'CLEF_LOCATION_MATERIEL': {
          'typeParam': 'int',
          'valeur': this.mouvement ? this.mouvement['id'] || 0 : '0'
        },
        'DATE_DEBUT': {
          'typeParam': 'date',
          'valeur': datestart
        },
        'DATE_FIN': {
          'typeParam': 'date',
          'valeur': dateend
        },
        'CRITERE': event || '',
        'CLEF_QUALIF_PERSONEL': {
          'typeParam': 'int',
          'valeur': '0'
        },
        'FILTRER_VISIBLE_PLANNING': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_CONTRAT_PERSO': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_AYANT_PRESTATION': {
          'typeParam': 'boolean',
          'valeur': this.common.local.getObject('paramSociete').equipier1PrestationParJour ? true : false
        }
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        const data = datas.data || [];
        this.listPersoPonctuel = data.length ? [{ id: 0, libelleObjetEntite: 'A définir' }] : [];
        data.forEach(elt => {
          console.log(listChauff)
          const existe = listChauff.find(t => t === elt.id);
          if (!existe || (this.chauffEdit === elt.id)) {
            if (elt.id) {
              elt.libelleObjetEntite = `${elt.matricule || ''} ${elt.nom || ''} ${elt.prenom || ''}`
            }
            // elt.libelleObjetEntite = `${elt.matricule || ''} ${elt.nom || ''} ${elt.prenom || ''}`;
            this.listPersoPonctuel.push(elt);
          }
        });
      }
    });
  }

  getCellClass({ row, column, value }): any {
    return {'devisNonValide': row.chauffeur && row.chauffeur.id ? false : true}
  }

  searchQualification(lead) {
    const list = this.common.getType('qualificationEquipe') || [];
    const test = [];
    if (lead) {
      list.forEach(elt => {
        if (elt.id) {
          test.push(elt);
        }
      });
      this.dataQualificationTrue = test;
      if (test.length) {
        this.objEquipe['qualificationLeader'] = this.objEquipe['qualificationLeader'] || test[0];
      }
    } else {
      if (list.length) {
        this.selectedQual = list[0]
      }
      this.dataQualification = list;
    }
  }

  addLigne() {
    const obj = Object.assign({}, this.selectedQual);
    this.selectedQual = false;
    const ctrl = this;
    ctrl.objEquipe['listePersonnelParPoste'] = ctrl.objEquipe['listePersonnelParPoste'] || [];
    ctrl.objEquipe['listePersonnelParPoste'].push({
      id: ((ctrl.objEquipe['listePersonnelParPoste'].length + 1) * -1),
      poste: { id: 0, qualification: obj }
    });
    ctrl.objEquipe['listePersonnelParPoste'] = [...ctrl.objEquipe['listePersonnelParPoste']];
    console.log(ctrl.objEquipe['listePersonnelParPoste']);
  }

  deleteLigne(row) {
    const ctrl = this;

    if (row.id < 0) {
      ctrl.objEquipe['listePersonnelParPoste'] = ctrl.objEquipe['listePersonnelParPoste'].filter(elt => elt !== row);
    } else {
      if (row.poste && row.poste.id) {
        row.poste['posteDesactiveParDefault'] = true;
        row.chauffeur = row.chauffeur || { id: 0 };
        row.chauffeur.posteSupprime = true;
      }
    }

  }

  closeModalEquipe() {
    this.objEquipe = {};
    this.selectedQual = false;
  }

  objMvtEquipe() {
    const ObjetRetour: any = {};

    console.log(this.objEquipe)
    ObjetRetour.listePersonnelParPoste = [];
    ObjetRetour.listePersonnelParPosteMvt = [];
    ObjetRetour.listePostes = [];
    ObjetRetour.leaderEquipe = this.objEquipe['leaderEquipe'];
    ObjetRetour.qualificationLeader = this.objEquipe['qualificationLeader'];
    ObjetRetour.chauffeur = this.objEquipe['chauffeur'];
    ObjetRetour.modeEquipe = this.objEquipe['modeEquipe'] || false;
    this.objEquipe['listePersonnelParPoste'] = this.objEquipe['listePersonnelParPoste'] || [];
    ObjetRetour.equipeDefinie = this.objEquipe['listePersonnelParPoste'].length ? true : false;

    this.objEquipe['listePersonnelParPoste'].forEach(elt => {
      ObjetRetour.listePostes.push(elt.poste);
      const defaut = {
        id: 0,
        poste: elt.poste,
        chauffeur: elt.personnelDefaut || { id: 0 }
      };
      const ponctuel = {
        id: 0,
        poste: elt.poste,
        chauffeur: elt.chauffeur || { id: 0 }
      }
      ObjetRetour.listePersonnelParPoste.push(defaut);
      ObjetRetour.listePersonnelParPosteMvt.push(ponctuel);
    });
    ObjetRetour.equipeDefinie = ObjetRetour.listePostes.length > 0 ? true : false;
    return ObjetRetour;
  }

  revertEquipe() {
    this.objEquipe['leaderEquipe'] = {};
    this.objEquipe['modeEquipe'] = false;
    this.objEquipe['listePersonnelParPoste'] = [];
  }

  fermer() {
    this.closeModalEquipe();
    this.hidefunction.emit();
  }

  parseMouvement() {
    const ctrl = this;
    const data = Object.assign({}, ctrl.mouvement);
    const chantier = data.chantier || { id: 0 };
    data.listLieu = data.listLieu || [];
    data.listLieu.forEach(elt => elt.libelleObjetEntite = elt.nom);
    this.listLieu = [...this.listLieu, ...(data.listLieu || [])];
    ctrl.objEquipe = data
    console.log(ctrl.objEquipe);
  }

  saveFct() {
    console.log(this.objEquipe)
    this.save.emit(this.objEquipe);
  }

  getListLieuDepart() {
    this.listLieuDepart = [{ id: 0, libelleObjetEntite: 'Non spécifié' }];
    const param = {
      'servlet': 'DBGestionLieuDepart',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        const data = datas.data || [];
        data.forEach(elt => {
          this.listLieuDepart.push(elt);
        });
      }
    });
  }

  listePersonnelParPoste() {
    this.objEquipe['listePersonnelParPoste'] = this.objEquipe['listePersonnelParPoste'] || [];
    return this.objEquipe['listePersonnelParPoste'].filter(elt => !elt.chauffeur || (elt.chauffeur && !elt.chauffeur.posteSupprime));
  }
  
  clickAddPost() {
    this.common.openModal(this.modalService, this.qualificationTemp)
  }


}
